import { Select, Input } from 'semantic-ui-react';
import {
  age,
  errorInput,
  eventSlugnameTrim,
  formInput,
  formLabel,
  formSelectService,
  s,
  sortArray,
  searchSelectProps,
} from '../../../../components/helpers';
import { spouseGender } from '../../../../pages/events/reservation';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import EventService from '../../../../services/api/eventService';

export const reservationRequiresCivil = (eventName = '') => {
  const name = String(eventName || '').toLowerCase();
  return (
    (name.includes('eminario') && (name.includes('mor') || name.includes('atrimonio'))) ||
    (name.includes('trenamiento') && name.includes('uevos'))
  );
};

const eventNameLower = (eventName = '') => String(eventName || '').toLowerCase();

export const isEncuentroEventName = (eventName = '') =>
  eventNameLower(eventName).includes('ncuentro');

export const isTeenEncuentroEvent = (eventName = '') => {
  const name = eventNameLower(eventName);
  return isEncuentroEventName(name) && name.includes('13_a_17');
};

export const isTeenEncuentroChicas = (eventName = '') =>
  isTeenEncuentroEvent(eventName) && eventNameLower(eventName).includes('chicas');

export const isTeenEncuentroChicos = (eventName = '') =>
  isTeenEncuentroEvent(eventName) && eventNameLower(eventName).includes('chicos');

export const encuentroAgeNotice = (eventName = '') => {
  if (isTeenEncuentroChicas(eventName)) {
    return 'La inscripción a este encuentro está disponible solo para chicas de 13 a 17 años.';
  }
  if (isTeenEncuentroChicos(eventName)) {
    return 'La inscripción a este encuentro está disponible solo para chicos de 13 a 17 años.';
  }
  if (isTeenEncuentroEvent(eventName)) {
    return 'La inscripción a este encuentro está disponible solo para personas de 13 a 17 años.';
  }
  if (isEncuentroEventName(eventName)) {
    return 'La inscripción al encuentro está disponible solo para personas de 18 años o más.';
  }
  return '';
};

const requiresGuardianForReservation = (eventName, birthdate) =>
  age(birthdate) <= 14 ||
  (eventNameLower(eventName).includes('camp') && age(birthdate) < 18) ||
  (isTeenEncuentroEvent(eventName) && age(birthdate) < 18);

export const ReservationExtraInfo = (props) => {
  const { inputs, handleInputs, selectHandle, errorInputs, defaulteventSlugname, event } = props;
  const notUpdatedGroups = () =>
    inputs?.groupLeader?.filter?.((group) => moment().diff(group.updatedAt, 'days') >= 2);

  const eventName = defaulteventSlugname()?.toLowerCase();

  return (
    <>
      {!!(inputs.birthdate && requiresGuardianForReservation(eventName, inputs.birthdate)) && (
        <>
          <div>
            {formLabel('parentFullname', 'Nombre del acudiente')}
            {formInput({
              Input,
              handler: handleInputs,
              label: 'Nombre del acudiente',
              name: 'parentFullname',
              value: inputs.parentFullname || '',
              errorInputs,
            })}
            {formLabel('parentIdentification', 'Cédula del acudiente')}
            {formInput({
              Input,
              handler: handleInputs,
              label: 'Cédula del acudiente',
              name: 'parentIdentification',
              value: inputs.parentIdentification || '',
              errorInputs,
              type: 'number',
            })}
          </div>
        </>
      )}
      {eventName?.includes('ntrenadores') && eventName?.includes('deres') && (
        <div>
          {formLabel('perfil_de_lider', 'Selecciona tu perfil de lider')}
          <Select
            placeholder={'Selecciona tu perfil de lider'}
            className={errorInputs?.perfil_de_lider || ''}
            style={{ margin: '0 0 20px 0' }}
            {...searchSelectProps({
              name: 'perfil_de_lider',
              value: inputs?.perfil_de_lider || '',
              handler: selectHandle,
              options: sortArray(['Entrenador', 'Líder de Grupo']).map((a) => {
                return { key: a, value: a, text: a };
              }),
            })}
          />
        </div>
      )}
      {(eventName?.includes('navidad') || eventName?.includes('experiencia')) && (
        <div>
          {formLabel('rol', 'Selecciona tu rol')}
          <small style={{ display: 'block', margin: '0' }}>
            Si tienes varios roles, escoger el de mayor nivel.
          </small>
          <Select
            placeholder={'Selecciona tu rol'}
            className={errorInputs?.rol ? 'error' : ''}
            style={{ margin: '0 0 20px 0' }}
            {...searchSelectProps({
              name: 'rol',
              value: inputs?.rol,
              handler: selectHandle,
              options: sortArray([
                'Voluntario de Experiencia',
                ...(eventName?.includes('navidad')
                  ? ['Líder o Entrenador de Grupos', 'Facilitador de Seminario', 'Staff']
                  : [
                      'Entrenador de Experiencia',
                      'Coordinador',
                      'Encargado',
                      'Encargado Jr',
                      'Directores y Conectores',
                    ]),
              ]).map((a) => {
                return { key: a, value: a, text: a };
              }),
            })}
          />
        </div>
      )}
      {eventName?.includes('ncuentro') && (
        <>
          <p>{encuentroAgeNotice(eventName)}</p>
          <div style={{ margin: '0 0 20px 0' }}>
            {formLabel('asistes_a_grupo', '¿Asistes a un grupo?')}
            {formSelectService({
              Select,
              handler: selectHandle,
              label: '¿Asistes a un grupo?',
              name: 'asistes_a_grupo',
              value: inputs.asistes_a_grupo || '',
              errorInputs,
              options: ['Sí', 'No'],
            })}
          </div>
          <div style={{ margin: '0 0 20px 0' }}>
            {formLabel('nombre_de_contacto', 'Nombre de un familiar o amigo')}
            {formInput({
              Input,
              handler: handleInputs,
              label: `Nombre de un familiar o amigo`,
              name: `nombre_de_contacto`,
              value: inputs[`nombre_de_contacto`],
              errorInputs,
            })}
          </div>
          <div style={{ margin: '0 0 20px 0' }}>
            {formLabel('parentesco_de_contacto', 'Parentesco del familiar o amigo')}
            {formInput({
              Input,
              handler: handleInputs,
              label: `Parentesco del familiar o amigo`,
              name: `parentesco_de_contacto`,
              value: inputs[`parentesco_de_contacto`],
              errorInputs,
            })}
          </div>
          <div style={{ margin: '0 0 20px 0' }}>
            {formLabel('telefono_de_contacto', 'Teléfono del familiar o amigo')}
            {formInput({
              Input,
              handler: handleInputs,
              label: `Teléfono del familiar o amigo`,
              name: `telefono_de_contacto`,
              type: 'number',
              value: inputs[`telefono_de_contacto`],
              errorInputs,
            })}
          </div>
        </>
      )}
      {reservationRequiresCivil(eventName) &&
        !!inputs.civil &&
        inputs.civil !== 'Soltero' &&
        !(eventName?.includes('trenamiento') && eventName?.includes('uevos')) && (
          <div style={{ margin: '0 0 20px 0' }}>
            {formLabel(
              `nombre_${spouseGender(inputs.gender)}`,
              `Nombre de ${spouseGender(inputs.gender)}`
            )}
            {formInput({
              Input,
              handler: handleInputs,
              label: `Nombre de ${spouseGender(inputs.gender)}`,
              name: `nombre_${spouseGender(inputs.gender)}`,
              value: inputs[`nombre_${spouseGender(inputs.gender)}`],
              errorInputs,
            })}
            {formLabel(
              `cedula_${spouseGender(inputs.gender)}`,
              `Cédula de ${spouseGender(inputs.gender)}`
            )}
            {formInput({
              Input,
              handler: handleInputs,
              label: `Cédula de ${spouseGender(inputs.gender)}`,
              name: `cedula_${spouseGender(inputs.gender)}`,
              value: inputs[`cedula_${spouseGender(inputs.gender)}`],
              type: 'number',
              errorInputs,
            })}
            {formLabel(
              `edad_${spouseGender(inputs.gender)}`,
              `Edad de ${spouseGender(inputs.gender)}`
            )}
            {formInput({
              Input,
              handler: handleInputs,
              label: `Edad de ${spouseGender(inputs.gender)}`,
              name: `edad_${spouseGender(inputs.gender)}`,
              value: inputs[`edad_${spouseGender(inputs.gender)}`],
              type: 'number',
              errorInputs,
            })}
            {formLabel(
              `telefono_${spouseGender(inputs.gender)}`,
              `Teléfono de ${spouseGender(inputs.gender)}`
            )}
            {formInput({
              Input,
              handler: handleInputs,
              label: `Teléfono de ${spouseGender(inputs.gender)}`,
              name: `telefono_${spouseGender(inputs.gender)}`,
              value: inputs[`telefono_${spouseGender(inputs.gender)}`],
              errorInputs,
            })}
            {formLabel(
              `email_${spouseGender(inputs.gender)}`,
              `Email de ${spouseGender(inputs.gender)}`
            )}
            {formInput({
              Input,
              handler: handleInputs,
              label: `Email de ${spouseGender(inputs.gender)}`,
              name: `email_${spouseGender(inputs.gender)}`,
              value: inputs[`email_${spouseGender(inputs.gender)}`],
              errorInputs,
            })}
          </div>
        )}
      {eventName?.includes('camp') && (
        <div style={{ margin: '0 0 20px 0' }}>
          {formLabel(`limitacion_fisica_bool`, '¿El campista tiene alguna limitación fisica?')}
          {formSelectService({
            Select,
            handler: selectHandle,
            label: '¿El campista tiene alguna limitación fisica?',
            name: 'limitacion_fisica_bool',
            value: inputs.limitacion_fisica_bool || '',
            errorInputs,
            options: ['Si', 'No'],
          })}
          {inputs.limitacion_fisica_bool === 'Si' &&
            formInput({
              Input,
              handler: handleInputs,
              label: '¿Cuál?',
              name: 'limitacion_fisica',
              value: inputs.limitacion_fisica,
              errorInputs,
            })}
        </div>
      )}
      {eventName?.includes('eminario') && eventName?.includes('eroes') && (
        <>
          <div style={{ margin: '0 0 20px 0' }}>
            {formLabel(`recibe_seminario`, 'Selecciona como recibirás el seminario')}
            {formSelectService({
              Select,
              handler: selectHandle,
              label: 'Selecciona como recibirás el seminario',
              name: 'recibe_seminario',
              value: inputs.recibe_seminario || '',
              errorInputs,
              options: [
                'Abuela',
                'Abuelo',
                'Abuelos (En pareja)',
                'Madre Soltera',
                'Maestro',
                'Padre Soltero',
                'Padres (en pareja)',
                'Soltero (no son padres)',
                'Otro',
              ],
            })}
            {inputs.recibe_seminario === 'Otro' &&
              formInput({
                Input,
                handler: handleInputs,
                label: 'Otro, ¿Cuál?',
                name: 'recibe_seminario_otro',
                value: inputs.recibe_seminario_otro,
                errorInputs,
              })}
          </div>
          <div style={{ margin: '0 0 20px 0' }}>
            {formLabel(
              `edad_hijos`,
              '¿Qué edad de tus hijos quieres profundizar en el grupo de socialización?'
            )}
            {formInput({
              Input,
              handler: handleInputs,
              label: '¿Qué edad de tus hijos quieres profundizar en el grupo de socialización?',
              name: 'edad_hijos',
              value: inputs.edad_hijos || '',
              errorInputs,
              type: 'number',
              min: 0,
              max: 18,
            })}
          </div>
        </>
      )}
      {eventName?.includes('seminario') && eventName?.includes('ideologico') && (
        <>
          <div style={{ margin: '0 0 20px 0' }}>
            {formLabel(
              `rol_seminario_ideologico`,
              'Selecciona el perfil con el cual deseas registrarte:'
            )}
            {formSelectService({
              Select,
              handler: selectHandle,
              label: 'Selecciona el perfil con el cual deseas registrarte:',
              name: 'rol_seminario_ideologico',
              value: inputs.rol_seminario_ideologico || '',
              errorInputs,
              options: [
                'Líder de grupo o equipo de discipulado',
                'Facilitador de seminario',
                'Entrenador de experiencia',
                'Conector de experiencia',
                'Coordinador de experiencia',
                'Encargado o Encargado Junior de experiencia',
                'Docente',
              ],
            })}
          </div>
          {inputs.rol_seminario_ideologico === 'Líder de grupo o equipo de discipulado' && (
            <div style={{ margin: '0 0 20px 0' }}>
              <p style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: 'bold' }}>
                Tienes la opción de llevar un timoteo para que te acompañe en el seminario.
              </p>
              {formLabel('nombre_timoteo', '¿Cuál es el nombre del timoteo que llevarás?')}
              {formInput({
                Input,
                handler: handleInputs,
                label: '¿Cuál es el nombre del timoteo que llevarás?',
                name: 'nombre_timoteo',
                value: inputs.nombre_timoteo,
                errorInputs,
              })}
              {formLabel('cedula_timoteo', '¿Cuál es la cédula del timoteo que llevarás?')}
              {formInput({
                Input,
                handler: handleInputs,
                label: '¿Cuál es la cédula del timoteo que llevarás?',
                name: 'cedula_timoteo',
                value: inputs.cedula_timoteo,
                errorInputs,
                type: 'number',
              })}
              {formLabel('telefono_timoteo', '¿Cuál es el teléfono del timoteo que llevarás?')}
              {formInput({
                Input,
                handler: handleInputs,
                label: '¿Cuál es el teléfono del timoteo que llevarás?',
                name: 'telefono_timoteo',
                value: inputs.telefono_timoteo,
                errorInputs,
                type: 'number',
              })}
            </div>
          )}
        </>
      )}
      {eventName === 'crecer_presencial' && (
        <div>
          {formLabel(`crecer_paso`, 'A que paso de crecer te vas a inscribir')}
          <Select
            placeholder={'A que paso de crecer te vas a inscribir'}
            id={'crecer_paso'}
            className={`Registration__input Registration__input-${'crecer_paso'} ${
              errorInputs['crecer_paso'] ? 'error' : ''
            }`}
            {...searchSelectProps({
              name: 'crecer_paso',
              value: inputs.crecer_paso || '',
              handler: selectHandle,
              options: ['Crecer_Vida', 'Crecer_Influencia'].map((opt) => {
                return { key: opt, value: opt, text: eventSlugnameTrim(opt) };
              }),
            })}
          />
        </div>
      )}
      {eventName?.includes('ntrenamiento') && eventName?.includes('deres') && false && (
        <>
          {notUpdatedGroups()?.length ? (
            <div style={{ margin: '0 0 25px 0' }}>
              <p>
                Te pedimos que por favor actualices la información de tu
                {s(notUpdatedGroups()?.length)} grupo{s(notUpdatedGroups()?.length)} para continuar
                con el registro <br />
                Actualiza haciendo clic en el nombre de tu grupo ⬇️
              </p>
              <p style={{ margin: '15px 0 5px 0' }}>
                <strong>Última vez actualizado:</strong>
              </p>
              {notUpdatedGroups().map((group) => (
                <p style={{ margin: '5px 0' }}>
                  <Link
                    to={`/grupos/lider?phone=${inputs.phone}&identification=${inputs.identification}&event=Entrenamiento_para_Lideres&activityName=${group.activityName}`}
                  >
                    <strong>{group.groupName}:</strong>{' '}
                    {moment(group.updatedAt).tz('America/Bogota').format('DD [de] MMMM [de] YYYY')}
                  </Link>
                </p>
              ))}
              <p style={{ margin: '15px 0 5px 0' }}>
                Una vez termines de actualizar, haz clic en el botón "Guardar y continuar registro"
                en la edición de tú grupo.
              </p>
            </div>
          ) : (
            <p>¡No tienes grupos pendientes por ser actualizados!</p>
          )}
        </>
      )}

      {eventName?.includes('timoteo') && (
        <>
          {formLabel(`nombre_lider_grupo`, '¿Cuál es el nombre del líder que te invitó?')}
          {formInput({
            Input,
            handler: handleInputs,
            label: '¿Cuál es el nombre del líder que te invitó?',
            name: 'nombre_lider_grupo',
            value: inputs.nombre_lider_grupo,
            errorInputs,
          })}
          {formLabel(`cedula_lider_grupo`, '¿Cuál es la cédula del líder que te invitó?')}
          {formInput({
            Input,
            handler: handleInputs,
            label: '¿Cuál es la cédula del líder que te invitó?',
            name: 'cedula_lider_grupo',
            value: inputs.cedula_lider_grupo,
            errorInputs,
            type: 'number',
          })}
        </>
      )}
      {eventName?.includes('ntrenamiento') &&
        eventName?.includes('deres') &&
        formSelectService({
          Select,
          handler: selectHandle,
          label: '¿Tu grupo esta actualmente activo?',
          name: 'grupo_activo',
          value: inputs.grupo_activo || '',
          errorInputs,
          options: ['Si', 'No'],
        })}
      <div>
        {event?.additionalinformation?.extraInfo?.map((input) => {
          return (
            <>
              {formLabel(input.name, input.label.replace(/_/g, ' '))}
              {formInput({
                Input,
                handler: handleInputs,
                label: input.label.replace(/_/g, ' '),
                name: input.name,
                value: inputs[input.name],
                errorInputs,
                type: input.type,
              })}
            </>
          );
        })}
      </div>
    </>
  );
};

export const verifyReservationForm = (event, defaulteventSlugname, inputs, set_errorInputs) => {
  const eventName = defaulteventSlugname()?.toLowerCase();

  let mandatoryInputs = ['name', 'lastName', 'birthdate', 'gender', 'identification', 'phone'];

  if (event?.additionalinformation?.extraInfo) {
    event?.additionalinformation?.extraInfo.forEach((input) => {
      if (input.mandatory) {
        mandatoryInputs = [...mandatoryInputs, input.name];
      }
    });
  }

  if (!defaulteventSlugname()?.toLowerCase()?.includes('crecer')) {
    mandatoryInputs = [...mandatoryInputs, 'email'];
  }

  if (requiresGuardianForReservation(eventName, inputs.birthdate)) {
    mandatoryInputs = [...mandatoryInputs, 'parentIdentification', 'parentFullname'];
  }

  if (eventName?.includes('navidad') || eventName?.includes('experiencia')) {
    mandatoryInputs = [...mandatoryInputs, 'rol'];
  }

  if (eventName?.includes('128') && eventName?.includes('ruta')) {
    if (inputs.gender !== 'Masculino') {
      Swal.fire('Lo sentimos, solo está permitida la entrada para hombres.');
      mandatoryInputs = [...mandatoryInputs, 'Not_complaint_ruta'];
    }
  }

  if (eventName?.includes('ntrenadores') && eventName?.includes('deres')) {
    mandatoryInputs = [...mandatoryInputs, 'perfil_de_lider'];
  }

  if (eventName?.includes('timoteo')) {
    mandatoryInputs = [...mandatoryInputs, 'nombre_lider_grupo', 'cedula_lider_grupo'];
  }

  if (eventName?.includes('eminario')) {
    if (eventName?.includes('eroes')) {
      mandatoryInputs = [...mandatoryInputs, 'recibe_seminario', 'edad_hijos'];
    }
  }

  if (reservationRequiresCivil(eventName)) {
    mandatoryInputs = [...mandatoryInputs, 'civil'];
    if (
      !!inputs.civil &&
      inputs.civil !== 'Soltero' &&
      !(eventName?.includes('trenamiento') && eventName?.includes('uevos'))
    ) {
      mandatoryInputs = [...mandatoryInputs, `nombre_${spouseGender(inputs.gender)}`];
      mandatoryInputs = [...mandatoryInputs, `cedula_${spouseGender(inputs.gender)}`];
      mandatoryInputs = [...mandatoryInputs, `telefono_${spouseGender(inputs.gender)}`];
    }
  }

  if (eventName?.includes('seminario') && eventName?.includes('ideologico')) {
    mandatoryInputs = [...mandatoryInputs, 'rol_seminario_ideologico'];
  }

  if (eventName?.includes('ncuentro')) {
    mandatoryInputs = [
      ...mandatoryInputs,
      'asistes_a_grupo',
      'nombre_de_contacto',
      'parentesco_de_contacto',
      'telefono_de_contacto',
    ];
    if (isTeenEncuentroEvent(eventName)) {
      const years = age(inputs.birthdate);
      if (inputs.birthdate && (years < 13 || years > 17)) {
        Swal.fire('Lo sentimos, este encuentro es solo para personas entre 13 y 17 años.');
        mandatoryInputs = [...mandatoryInputs, 'Not_complaint_encuentro'];
      } else if (
        isTeenEncuentroChicas(eventName) &&
        inputs.gender &&
        inputs.gender !== 'Femenino'
      ) {
        Swal.fire('Lo sentimos, este encuentro es solo para chicas.');
        mandatoryInputs = [...mandatoryInputs, 'Not_complaint_encuentro_gender'];
      } else if (
        isTeenEncuentroChicos(eventName) &&
        inputs.gender &&
        inputs.gender !== 'Masculino'
      ) {
        Swal.fire('Lo sentimos, este encuentro es solo para chicos.');
        mandatoryInputs = [...mandatoryInputs, 'Not_complaint_encuentro_gender'];
      }
    } else if (inputs.birthdate && age(inputs.birthdate) < 18) {
      Swal.fire(
        'Lo sentimos, solo está permitida la inscripción al encuentro desde los 18 años de edad.'
      );
      mandatoryInputs = [...mandatoryInputs, 'Not_complaint_encuentro'];
    }
  }

  if (eventName?.includes('campamento_cyphers_mas_1821')) {
    const years = age(inputs.birthdate);
    if (inputs.birthdate && (years < 16 || years > 24)) {
      Swal.fire('Lo sentimos, tu edad no es permitida para inscribirte a este campamento.');
      mandatoryInputs = [...mandatoryInputs, 'Not_complaint_cyphers'];
    }
  }

  if (eventName?.includes('camp')) {
    mandatoryInputs = [...mandatoryInputs, 'limitacion_fisica_bool'];
    if (inputs.limitacion_fisica_bool === 'Si') {
      mandatoryInputs = [...mandatoryInputs, 'limitacion_fisica'];
    }
  }

  if (eventName === 'crecer_presencial') {
    mandatoryInputs = [...mandatoryInputs, 'crecer_paso'];
  }

  if (
    parseInt(event?.paidEvent, 10) > 0 ||
    Math.abs(parseInt(inputs.volunteerDonationAmount)) > 0
  ) {
    mandatoryInputs = [...mandatoryInputs, 'es_tarjetahabiente'];
    if (inputs.es_tarjetahabiente === 'No') {
      mandatoryInputs = [
        ...mandatoryInputs,
        'nombre_tarjetahabiente',
        'identificacion_tarjetahabiente',
      ];
    }
  }

  let errorInputs = {};

  mandatoryInputs.forEach((input) => {
    errorInputs = errorInput({
      errorInputs,
      input: { name: input, value: inputs[input] },
    });
  });

  if (inputs?.crecer_previo) {
    errorInputs = errorInput({
      errorInputs,
      input: {
        name: 'crecer_previo',
        value: Boolean(inputs?.crecer_previo?.length > 0),
      },
    });
  }

  if (inputs?.identification && inputs?.identification?.length <= 5) {
    errorInputs = errorInput({
      errorInputs,
      input: {
        name: 'identification',
        value: inputs?.identification.length >= 5,
      },
    });
  }

  if (inputs?.phone && inputs?.phone?.length <= 10) {
    errorInputs = errorInput({
      errorInputs,
      input: {
        name: 'phone',
        value: inputs?.phone.length >= 10,
      },
    });
  }

  const isBaptismEvent = eventName?.includes('bauti');
  const isEncuentroEvent = isEncuentroEventName(eventName);
  if (isBaptismEvent && inputs.birthdate && age(inputs.birthdate) < 13) {
    Swal.fire(
      'Lo sentimos, solo está permitida la inscripción al bautismo desde los 13 años de edad.'
    );
    errorInputs = {
      ...errorInputs,
      age: true,
    };
  } else if (!isBaptismEvent && !isEncuentroEvent && age(inputs.birthdate) < 4) {
    Swal.fire('Lo sentimos, solo está permitida la entrada desde los 4 años de edad.');
    errorInputs = {
      ...errorInputs,
      age: true,
    };
  }

  set_errorInputs(errorInputs);
  return Object.values(errorInputs)?.includes(true);
};

export const sendReservationHelper = ({
  inputs,
  event,
  eventSlugname,
  special,
  eventSelected = {},
}) => {
  let aditionalinformation = {};

  if (inputs.nombre_timoteo) aditionalinformation.nombre_timoteo = inputs.nombre_timoteo;
  if (inputs.cedula_timoteo) aditionalinformation.cedula_timoteo = inputs.cedula_timoteo;
  if (inputs.telefono_timoteo) aditionalinformation.telefono_timoteo = inputs.telefono_timoteo;
  if (inputs.asistes_a_grupo) aditionalinformation.asistes_a_grupo = inputs.asistes_a_grupo;
  if (inputs.rol) aditionalinformation.rol = inputs.rol;
  if (inputs.perfil_de_lider) aditionalinformation.perfil_de_lider = inputs.perfil_de_lider;
  if (inputs.ciudad) aditionalinformation.ciudad = inputs.ciudad;
  if (inputs.limitacion_fisica) aditionalinformation.limitacion_fisica = inputs.limitacion_fisica;
  if (inputs.nombre_lider) aditionalinformation.nombre_lider = inputs.nombre_lider;
  if (inputs.telefono_lider) aditionalinformation.telefono_lider = inputs.telefono_lider;
  if (inputs.edad_hijos) aditionalinformation.edad_hijos = inputs.edad_hijos;
  if (inputs.civil) aditionalinformation.civil = inputs.civil;
  if (inputs.grupo_activo) aditionalinformation.grupo_activo = inputs.grupo_activo;
  if (inputs.rol_seminario_ideologico)
    aditionalinformation.rol_seminario_ideologico = inputs.rol_seminario_ideologico;
  if (inputs.nombre_de_contacto)
    aditionalinformation.nombre_de_contacto = inputs.nombre_de_contacto;
  if (inputs.parentesco_de_contacto)
    aditionalinformation.parentesco_de_contacto = inputs.parentesco_de_contacto;
  if (inputs.telefono_de_contacto)
    aditionalinformation.telefono_de_contacto = inputs.telefono_de_contacto;
  if (inputs.tienes_lider) aditionalinformation.tienes_lider = inputs.tienes_lider;
  if (inputs.recibe_seminario) aditionalinformation.recibe_seminario = inputs.recibe_seminario;
  if (inputs.recibe_seminario_otro)
    aditionalinformation.recibe_seminario_otro = inputs.recibe_seminario_otro;
  if (inputs.crecer_previo) aditionalinformation.crecer_previo = inputs?.crecer_previo?.join(', ');
  if (inputs.crecer_paso) aditionalinformation.crecer_paso = inputs.crecer_paso;
  if (inputs.nombre_lider_grupo)
    aditionalinformation.nombre_lider_grupo = inputs.nombre_lider_grupo;
  if (inputs.cedula_lider_grupo)
    aditionalinformation.cedula_lider_grupo = inputs.cedula_lider_grupo;
  if (inputs[`nombre_${spouseGender(inputs.gender)}`])
    aditionalinformation[`nombre_${spouseGender(inputs.gender)}`] =
      inputs[`nombre_${spouseGender(inputs.gender)}`];
  if (inputs[`cedula_${spouseGender(inputs.gender)}`])
    aditionalinformation[`cedula_${spouseGender(inputs.gender)}`] =
      inputs[`cedula_${spouseGender(inputs.gender)}`];
  if (inputs[`edad_${spouseGender(inputs.gender)}`])
    aditionalinformation[`edad_${spouseGender(inputs.gender)}`] =
      inputs[`edad_${spouseGender(inputs.gender)}`];
  if (inputs[`telefono_${spouseGender(inputs.gender)}`])
    aditionalinformation[`telefono_${spouseGender(inputs.gender)}`] =
      inputs[`telefono_${spouseGender(inputs.gender)}`];
  if (inputs[`email_${spouseGender(inputs.gender)}`])
    aditionalinformation[`email_${spouseGender(inputs.gender)}`] =
      inputs[`email_${spouseGender(inputs.gender)}`];

  if (event?.additionalinformation?.extraInfo) {
    event?.additionalinformation?.extraInfo.forEach((input) => {
      aditionalinformation = {
        ...aditionalinformation,
        [input.name]: inputs[input.name],
      };
    });
  }

  let service = { ...(inputs.service || {}), ...eventSelected };
  if (!service?.id && !inputs.serviceArea) {
    service = { ...service, ...event };
  }

  return EventService.MakeAReservation({
    ...inputs,
    email: inputs.email || 'NA',
    aditionalinformation,
    eventSlugname,
    special,
    service,
  });
};
